<template>
  <div
    class="page-container"
    @touchstart="handleTouchStart"
    @touchend="handleTouchEnd"
  >
    <Toast position="bottom-center" />
    <!--   <div class="header h3 text-start pb-3">Липидный профиль</div> -->
    <div class="chart-container">
      <!-- Показатели и график -->
      <div class="chart-row">
        <!-- Показатели -->
        <!--       <div class="vertical-label">
        <span>ммоль/л</span>
      </div> -->

        <!-- Прокручиваемый график -->
        <div class="chart-wrapper">
          <div class="scrollable-chart-container">
            <div class="chart-inner">
              <Chart
                type="line"
                :data="chartData"
                :options="chartOptions"
                height="200px"
                class="chart"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Легенда -->
      <div class="legend-title">
        <div class="legend-item">
          <span class="legend-circle" style="background-color: #ff6384"></span>
          ЛПНП
        </div>
        <div class="legend-item">
          <span class="legend-circle" style="background-color: #36a2eb"></span>
          ЛПВП
        </div>
        <div class="legend-item">
          <span class="legend-circle" style="background-color: #ffce56"></span>
          ТГ
        </div>
        <div class="legend-item">
          <span class="legend-circle" style="background-color: #4bc0c0"></span>
          ОХС
        </div>
      </div>
    </div>

    <div
      class="ps-2 pe-2 pe-0 py-2 mt-2 blocktext"
      style="border-left: 10px solid #ffce56"
    >
      Несмотря на положительную динамику, уровень ЛПНП попрежнему превышает
      целевые значения. Необходима консультация врача.
    </div>
    <div class="pt-4">
      <DataTable
        :value="analyses"
        tableStyle="min-width: 100%"
        class="analysis-table"
        :showHeader="false"
        :showGridlines="false"
      >
        <div style="width: 80%" class="ps-2"></div>
        <!-- Первая колонка: Дата и показатели -->
        <Column header="История показателей">
          <template #body="{ data }">
            <div class="analysis-info">
              <!-- Дата анализа -->
              <div class="analysis-date">{{ data.date }}</div>
              <!-- Показатели -->
              <div class="analysis-details">
                <span>ОХС: {{ data.ohs }}</span>
                <span>ТГ: {{ data.tg }}</span>
                <span>ЛПВП: {{ data.hdl }}</span>
                <span>ЛПНП: {{ data.ldl }}</span>
              </div>
            </div>
          </template>
        </Column>

        <!-- Вторая колонка: Иконка -->
        <Column class="w-24 !text-end">
          <template #body="">
            <div class="expand-icon" @click="viewresult = true">
              <i class="pi pi-chevron-right"></i>
            </div>
          </template>
        </Column>
      </DataTable>

      <div
        v-if="isLoading"
        class="card flex justify-center p-5"
        style="
          width: 100%;
          background-color: none;
          border: none;
          box-shadow: none;
        "
      >
        <ProgressSpinner
          style="
            width: 50px;
            height: 50px;
            border: none;
            background-color: none;
          "
          strokeWidth="1"
          fill="transparent"
          animationDuration=".5s"
          aria-label="Custom ProgressSpinner"
        />
      </div>
    </div>
    <!-- Плавающая кнопка -->
    <button class="floating-button" @click="visible = true">
      <i class="pi pi-plus"></i>
    </button>

    <div style="margin-bottom: 50px"></div>
    <Dialog
      v-model:visible="visible"
      modal
      header="Добавить запись"
      :style="{ width: '50vw' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <form @submit.prevent="handleAddLipids">
        <div class="row gy-2 overflow-hidden pt-2">
          <div class="col-12">
            <div class="form-floating mb-3">
              <FloatLabel variant="on">
                <InputText
                  id="fohs"
                  class="w-100"
                  v-model="lipids.total_cholesterol"
                />
                <label for="fohs">Общий холестерин (ммоль/л)</label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-12">
            <div class="form-floating mb-3">
              <FloatLabel variant="on">
                <InputText
                  id="last_name"
                  class="w-100"
                  v-model="lipids.triglycerides"
                />
                <label for="last_name">Триглицериды (ммоль/л)</label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-12">
            <div class="form-floating mb-3">
              <FloatLabel variant="on">
                <InputText id="last_name" class="w-100" v-model="lipids.hdl" />
                <label for="last_name">ЛПВП (ммоль/л)</label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-12">
            <div class="form-floating mb-3">
              <FloatLabel variant="on">
                <InputText id="last_name" class="w-100" v-model="lipids.ldl" />
                <label for="last_name">ЛПНП (ммоль/л)</label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-12">
            <div class="form-floating mb-3">
              <FloatLabel variant="on">
                <InputText id="last_name" class="w-100" />
                <label for="last_name">Липопротеин(а) (мг/дл)</label>
              </FloatLabel>
            </div>
          </div>
          <div class="d-grid px-2 py-3 py-md-5">
            <Button
              type="submit"
              label="Сохранить"
              severity="success"
              rounded
              raised
            />
          </div>
        </div>
      </form>
    </Dialog>

    <Dialog
      v-model:viewresult="visible"
      modal
      header="запись"
      :style="{ width: '50vw' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      test
    </Dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useToast } from "primevue/usetoast";
import ProgressSpinner from "primevue/progressspinner";
import Chart from "primevue/chart";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
// eslint-disable-next-line
import ColumnGroup from "primevue/columngroup"; // optional
// eslint-disable-next-line
import Row from "primevue/row"; // optional

import { addLipids } from "@/services/api";
import { fetchLipids, fetchLipids_onlyapi } from "@/services/api"; // Импорт функции GET-запроса

export default defineComponent({
  components: { Chart, DataTable, Column, ProgressSpinner },
  setup() {
    const isRefreshing = ref(false); // Флаг обновления
    const touchStartY = ref(0); // Координата начала касания
    const touchMoveY = ref(0); // Координата движения
    const toast = useToast();

    const handleTouchStart = (event: TouchEvent) => {
      touchStartY.value = event.touches[0].clientY; // Запоминаем начальную точку
    };

    const handleTouchMove = (event: TouchEvent) => {
      touchMoveY.value = event.touches[0].clientY; // Запоминаем текущую позицию
    };

    const handleTouchEnd = async () => {
      if (touchMoveY.value - touchStartY.value > 50) {
        // Если движение вниз > 50px
        isRefreshing.value = true;
        try {
          const data = await fetchLipids_onlyapi(); // Загружаем данные с API
          console.log("Обновленные данные:", data);
          // Обновляем локальное состояние
          analyses.value = data
            .map((item: any) => ({
              date: new Date(item.created_at).toLocaleDateString("ru-RU", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              }),
              ohs: item.total_cholesterol,
              tg: item.triglycerides,
              hdl: item.hdl,
              ldl: item.ldl,
              timestamp: new Date(item.created_at).getTime(),
            }))
            .sort((a: any, b: any) => b.timestamp - a.timestamp); // Обратная сортировка (свежие даты сверху);
        } catch (error) {
          console.error("Ошибка обновления данных:", error);
        } finally {
          isRefreshing.value = false;
        }
      }
      touchStartY.value = 0; // Сбрасываем значения
      touchMoveY.value = 0;
    };

    const showSuccess = () => {
      toast.add({
        severity: "success",
        summary: "Добавление записи",
        detail: "Запись успешно добавлена",
        life: 3000,
      });
    };

    const visible = ref(false);
    const viewresult = ref(false);
    const lipids = ref({
      total_cholesterol: "",
      triglycerides: "",
      ldl: "",
      hdl: "",
    });

    const errorMessage = ref("");
    const successMessage = ref("");
    const analyses = ref([]); // Состояние для таблицы
    const isLoading = ref(true); // Флаг загрузки данных

    const loadLipids = async () => {
      isLoading.value = true; // Включаем спиннер перед загрузкой
      try {
        const data = await fetchLipids(); // Получаем данные с сервера

        // Данные для таблицы: сортировка в обратном порядке
        analyses.value = data
          .map((item: any) => ({
            date: new Date(item.created_at).toLocaleDateString("ru-RU", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }), // Формат DD.MM.YYYY
            ohs: item.total_cholesterol,
            tg: item.triglycerides,
            hdl: item.hdl,
            ldl: item.ldl,
            timestamp: new Date(item.created_at).getTime(),
          }))
          .sort((a: any, b: any) => b.timestamp - a.timestamp); // Обратная сортировка (свежие даты сверху)

        // Данные для графика: хронологический порядок
        const sortedChartData = [...data].sort(
          (a: any, b: any) =>
            new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
        );

        chartData.value = {
          labels: sortedChartData.map((item: any) =>
            new Date(item.created_at).toLocaleDateString("ru-RU", {
              day: "2-digit",
              month: "2-digit",
            })
          ), // Формат DD/MM
          datasets: [
            {
              label: "ЛПНП",
              data: sortedChartData.map((item: any) => item.ldl),
              borderColor: "#FF6384",
              backgroundColor: "rgba(255, 99, 132, 0.2)",
              tension: 0.4,
            },
            {
              label: "ЛПВП",
              data: sortedChartData.map((item: any) => item.hdl),
              borderColor: "#36A2EB",
              backgroundColor: "rgba(54, 162, 235, 0.2)",
              tension: 0.4,
            },
            {
              label: "ТГ",
              data: sortedChartData.map((item: any) => item.triglycerides),
              borderColor: "#FFCE56",
              backgroundColor: "rgba(255, 206, 86, 0.2)",
              tension: 0.4,
            },
            {
              label: "ОХС",
              data: sortedChartData.map((item: any) => item.total_cholesterol),
              borderColor: "#4BC0C0",
              backgroundColor: "rgba(75, 192, 192, 0.2)",
              tension: 0.4,
            },
          ],
        };
      } catch (error: any) {
        errorMessage.value = error.message;
      } finally {
        isLoading.value = false; // Отключаем спиннер после завершения
      }
    };

    const sendLipidsToWebhook = async () => {
      try {
        const response = await fetch(
          "https://tiguglimgon.beget.app/webhook-test/a4c16163-b4bd-4831-987d-fd759d30d715",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(analyses.value),
          }
        );

        if (!response.ok) {
          throw new Error("Ошибка отправки данных на вебхук");
        }

        console.log("Данные успешно отправлены на вебхук");
      } catch (error) {
        console.error("Ошибка при отправке на вебхук:", error);
      }
    };

    const handleAddLipids = async () => {
      errorMessage.value = "";
      successMessage.value = "";

      try {
        const result = await addLipids({
          total_cholesterol: Number(lipids.value.total_cholesterol),
          triglycerides: Number(lipids.value.triglycerides),
          ldl: Number(lipids.value.ldl),
          hdl: Number(lipids.value.hdl),
          lpa: 0,
          ai_conclusion: "null",
        });

        // Сохраняем данные липидного профиля в localStorage для расчета рисков
        const lipidData = {
          total_cholesterol: Number(lipids.value.total_cholesterol),
          hdl: Number(lipids.value.hdl),
        };
        localStorage.setItem("lipid_data", JSON.stringify(lipidData));
        console.log(
          "Данные липидного профиля сохранены в localStorage для расчета рисков:",
          lipidData
        );

        successMessage.value = "Анализ успешно добавлен!";
        console.log("Ответ сервера:", result);
        await loadLipids();
        showSuccess();
        visible.value = false;
        resetForm(); // Сброс формы
        await sendLipidsToWebhook(); // Отправка данных на вебхук
        // eslint-disable-next-line
      } catch (error: any) {
        errorMessage.value = error.message;
      }
    };

    const resetForm = () => {
      lipids.value = {
        total_cholesterol: "",
        triglycerides: "",
        ldl: "",
        hdl: "",
      };
    };

    /* ≈ */

    const chartData = ref({
      labels: ["01/01", "02/01", "03/01", "04/01", "05/01"],
      datasets: [
        {
          label: "ЛПНП",
          data: [3.2, 3.4, 3.1, 2.9, 3.0],
          borderColor: "#FF6384",
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          tension: 0.4,
        },
        {
          label: "ЛПВП",
          data: [1.0, 1.2, 1.1, 1.3, 1.4],
          borderColor: "#36A2EB",
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          tension: 0.4,
        },
        {
          label: "ТГ",
          data: [1.5, 1.6, 1.4, 1.7, 1.6, 1.5],
          borderColor: "#FFCE56",
          backgroundColor: "rgba(255, 206, 86, 0.2)",
          tension: 0.4,
        },
        {
          label: "ОХС",
          data: [5.0, 5.1, 4.9, 5.2, 5.3, 5.0],
          borderColor: "#4BC0C0",
          backgroundColor: "rgba(75, 192, 192, 0.2)",
          tension: 0.4,
        },
      ],
    });

    const chartOptions = ref({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          position: "top",
          labels: {
            usePointStyle: true,
          },
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: "Дата",
          },
          ticks: {
            maxRotation: 0, // Углы меток оси X
            autoSkip: false, // Отключаем автоматическое пропускание меток
            padding: 10, // Расстояние между метками и графиком
          },
          grid: {
            display: false, // Отключаем сетку по оси X
          },
        },
        y: {
          title: {
            display: true,
            text: "ммоль/л",
          },
          beginAtZero: true,
          ticks: {
            padding: 10, // Расстояние между сеткой и значениями
          },
        },
      },
    });
    onMounted(() => {
      loadLipids(); // Загрузка данных при монтировании компонента
      const scrollableContainer = document.querySelector(
        ".scrollable-chart-container"
      );
      if (scrollableContainer) {
        scrollableContainer.scrollLeft = scrollableContainer.scrollWidth;
      }
    });
    return {
      analyses,
      chartData,
      chartOptions,
      visible,
      viewresult,
      lipids,
      handleAddLipids,
      errorMessage,
      successMessage,
      isLoading,
      isRefreshing,
      handleTouchStart,
      handleTouchMove,
      handleTouchEnd,
    };
  },
});
</script>

<style lang="scss">
.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* Легенда */
.legend-title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 10px;
}

/* Ряд с показателями и графиком */
.chart-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

/* Показатели: вертикальная полоска */
.vertical-label {
  writing-mode: vertical-rl; /* Вертикальный текст */
  transform: rotate(180deg); /* Инверсия текста для правильного чтения */
  text-align: center;
  font-size: 11px;
  font-weight: 500;
  margin-right: 5px;
  white-space: nowrap;
}

/* Оболочка графика */
.chart-wrapper {
  display: flex;
  flex: 1;
  /* height: 400px; /* Высота графика */
  overflow: hidden; /* Скрываем лишнее */
}

/* Прокручиваемая область графика */
.scrollable-chart-container {
  display: block;
  overflow-x: auto; /* Прокрутка по горизонтали */
  -webkit-overflow-scrolling: touch; /* Плавная прокрутка на мобильных устройствах */
  width: 100%;
}

.chart {
  min-width: calc(80vw - 1rem); /* Минимальная ширина графика */
}
.scrollable-chart-container {
  display: block;
  overflow-x: auto; /* Горизонтальная прокрутка */
  white-space: nowrap; /* Запрещаем перенос элементов */
  -webkit-overflow-scrolling: touch; /* Плавная прокрутка на мобильных устройствах */
  scroll-snap-align: end; /* Плавная прокрутка к концу */
  padding-bottom: 10px; /* Отступ снизу для прокрутки */
}

.chart-inner {
  min-width: 1500px; /* Минимальная ширина графика для свободных расстояний */
}
/* Легенда */
.legend-title {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  gap: 5px;
}

.legend-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}
.analysis-card {
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.analysis-card {
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Дата анализа */
.analysis-date {
  font-size: 14px !important;
  font-weight: bold;
  border-radius: 20px !important;
}

/* Показатели */
.analysis-details {
  font-size: 11px !important;
  color: #757575;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* Иконка раскрытия */
.expand-icon {
  font-size: 16px;
  color: #757575;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.p-card-body {
  padding: 12px;
}
.analysis-table .analysis-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px 0;
}

.analysis-table .analysis-date {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
}

.analysis-table .analysis-details {
  font-size: 12px;
  color: #757575;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.p-datatable-table-container {
  border-radius: 12px;
}
.floating-button {
  position: fixed;
  bottom: 20px; /* Отступ от нижнего края */
  right: calc(50% - 30px); /* Отступ от правого края */
  width: 60px; /* Диаметр кнопки */
  height: 60px; /* Диаметр кнопки */
  border-radius: 50%; /* Закругление до круга */
  background-color: #4caf50; /* Зеленый цвет */
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 24px; /* Размер значка */
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 3px 2px 7px #00000057;
}

.floating-button:hover {
  background-color: #45a049; /* Более темный зеленый при наведении */
}
.blocktext {
  background-color: #fff;
  border-radius: 10px !important;
  line-height: 1.2;
  font-size: 11pt;
  box-shadow: 2px 2px 10px #cecece57;
}
</style>
